import { createAction } from '@reduxjs/toolkit';

import { SIGN_UP_WITH_APPLE, SIGN_UP_WITH_GOOGLE, SUBMIT_REGISTRATION_FORM } from './actionTypes';
import { IOAuthRegistrationSubmitProps, IRegistrationSubmitProps } from './types';

export const submitRegistrationForm =
  createAction<IRegistrationSubmitProps>(SUBMIT_REGISTRATION_FORM);
export const signUpWithGoogle =
  createAction<IOAuthRegistrationSubmitProps>(SIGN_UP_WITH_GOOGLE);
export const signUpWithApple =
  createAction<IOAuthRegistrationSubmitProps>(SIGN_UP_WITH_APPLE);
